import { LitElement, html } from 'lit';
import styles from './studio-loader.css.mjs';

export class StudioLoader extends LitElement {
  static styles = styles;

  static properties = {
    size: { type: String, reflect: true }, // giant, large, medium, small, tiny
  };

  constructor() {
    super();
    this.size = 'medium'; // Default size
  }

  render() {
    return html`
      <div class="loader" role="status" aria-live="polite">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('studio-loader', StudioLoader);